function openModaleOtherFlavoursAddToCart($modalTrigger, isPDP, isPLP) {
    let $tile = $modalTrigger.closest('.item-addToCart');
    let url = $modalTrigger.attr('other-flavours-target');
    let dataListNameOrigin = $tile.closest('[data-list-name]').data('list-name');
    if (isPDP) {
        dataListNameOrigin = "productDetailOtherVarieties";
    } else if (window.location.pathname === homePageUrl || window.location.pathname === alternateHomePageFrUrl) {
        dataListNameOrigin = "homeOtherVarieties";
    }

    $('.displayVarietiesActive').removeClass('displayVarietiesActive');
    $tile.addClass('in-progress displayVarietiesActive');

    $tile.addClass('in-progress');
    $.ajax({
        type: "GET",
        url: url,
        contentType: 'application/json',
        dataType: 'html',
        cache: false,
        success: function (data) {
            replaceContentModalOtherFlavours(data, $tile, dataListNameOrigin, isPDP, isPLP);
        },
        complete: function () {
            $tile.removeClass('in-progress');
        },
        error: function (jqXHR) {
            TINK.redirectIfConflict(jqXHR);
        }
    });
}

function bindFlavoursModalActionExceptions() {
    let containerModale = $('#modal-add-to-cart-other-flavours');
    containerModale.modalActionsExceptions({
        ctaAddToCart: '[onclick*="addProductToCart"]',
        ctaAddToCartStarter: '.addToCartStarter',
        tabClose: '.modal-add-to-cart-other-flavours',
        tabsType: 'modal-other-flavours'
    });
}

function replaceContentModalOtherFlavours(data, productTile, dataListNameOrigin, isPDP, isPLP) {
    data = data.trim();
    if (window.location.pathname !== homePageUrl && window.location.pathname !== '/fr' && !isPDP && !isPLP) {
        upSellDisplay.displayVarietiesModal(data, dataListNameOrigin);
    }  else {
        // NEW UPSELL OTHER FLAVOURS PANEL
        upSellDisplay.displayUpsellSlide(data, productTile, dataListNameOrigin, isPDP, isPLP);

    }
}

function initOpenOtherFlavours (event, isPDP) {
    let isVarietiesDisplayed = $(event.currentTarget).closest('.item-addToCart');
    if (isVarietiesDisplayed.closest('.displayVarietiesActive ').length) {
        closeUpSellPanel();
        $('.displayVarietiesActive').removeClass('displayVarietiesActive');
    } else {
        pushDataLayerOtherFlavoursClick();
        closeUpSellPanel();
        openModaleOtherFlavoursAddToCart($(event.currentTarget), isPDP);
    }
}

$(document).on('click', '.btn--displayFlavours', function (event) {
    let isPLP = document.querySelectorAll('.products-search--grid').length;
    let isPlpBool = false;;
    if (isPLP) {
        isPlpBool = true;
    }

    if($(this).parents(".default-product-tile").hasClass("product-upSell-active")){
        $(".close-upSell-panel").click();
        return;
    }

    pushDataLayerOtherFlavoursClick();
    openModaleOtherFlavoursAddToCart($(event.currentTarget), false, isPlpBool);
});

$('.btn--pdp--displayFlavours').on('click', function(event) {
    pushDataLayerOtherFlavoursClick();
    openModaleOtherFlavoursAddToCart($(event.currentTarget), true, false);
});